export const MainNavbarWidth = '190px';
